import { lazy } from 'react';

const CharityVettingLegalRepresentativeEntry = lazy(
  () =>
    import(
      /* webpackChunkName: "CharityVettingLegalRepresentative" */ '../components/steps/legal-representative-step/LegalRepresentative'
    ),
);

export default CharityVettingLegalRepresentativeEntry;
